import { useEffect, useState } from "react";
import { Fullpage, Page } from "../../components/Sidebar";
import { GuestUserApi } from "../../services/GuestUserService";
import { toast } from "react-toastify";
// import { Eye } from "lucide-react";
import DocumentPreview from "../../components/DocumentPreview";


export default function GuestUserSidebar({ user, sidebar }: any) {
    const [users, setUsers] = useState<any[]>([]);
    const [selectedUser, setSelectedUser] = useState<any | null>(null);
    // const [userRole, setUserRole] = useState<string>("SuperAdmin");
    const { postUploadExcelForGuestUser, getGuestUser, uploadAppoinment, updateAppoinmentStatus, getAppoinmentForm, sendemailAndWhatsapp
    } = GuestUserApi()
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [previewFileUrl, setPreviewFileUrl] = useState<string | null>(null);
    const [previewFileType, setPreviewFileType] = useState<string | null>(null);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState<"accept" | "reject" | null>(null);
    const [searchEmail, setSearchEmail] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");

    const handleView = (url: string) => {
        setPreviewFileUrl(url);

        // Infer file type from URL
        if (url.endsWith(".pdf")) {
            setPreviewFileType("application/pdf");
        } else if (url.match(/\.(jpg|jpeg|png|webp|gif)$/)) {
            setPreviewFileType("image/*");
        } else {
            setPreviewFileType("unknown");
        }

        setIsPreviewOpen(true);
    };
    const handleUpload = async (id: number, docName: string, file: File) => {
        if (file.type !== "application/pdf") {
            alert("Only PDF files are allowed.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("userId", id.toString());
        formData.append("docName", docName);

        try {
            const response = await uploadAppoinment(formData, id.toString())

            if (response.data.status === 200) {
                alert("Document uploaded successfully!");
                // Optionally, trigger re-fetch of users or update UI
            } else {
                alert(`Upload failed: ${response.data.message}`);
            }
            getUser()

        } catch (error) {
            console.error("Error uploading file:", error);
            alert("Something went wrong during upload.");
        }
    };
    // const handleDeleteDocument = (id: number, docId: number) => {

    // }

    useEffect(() => {
        getUser()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const getUser = async () => {
        const response = await getGuestUser();
        setUsers(response.data.data)
    };



    const uploadDeptExcel = async (event: any) => {
        const fileInput = event.target;
        const file = fileInput.files?.[0];

        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            // setLoading(true);

            try {
                const response = await postUploadExcelForGuestUser(formData);
                if (response && response.data.status) {

                    if (response.data.status === 200) {
                        toast.success(response.data.message);
                    } else {
                        toast.error(response.data.message);
                    }

                } else {
                    toast.error('An error occurred while submitting the form.');
                }
            } catch (error) {
                toast.error('An error occurred while submitting the form.');
                console.error('Error:', error);
            } finally {
                setTimeout(() => {
                    // getCompanyData();
                    // setLoading(false);
                }, 3000);
                // Reset the file input field so that the same file can be uploaded again
                fileInput.value = '';
            }
        }
    };

    const handleDownloadPDF = async () => {
        try {
            const fileUrl = await getAppoinmentForm();
            if (!fileUrl) {
                alert("Could not fetch appointment form.");
                return;
            }

            // Fetch the file as a Blob
            const response = await fetch(fileUrl);
            if (!response.ok) throw new Error("Network response was not OK");

            const blob = await response.blob();

            // Create a temporary download link
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = "Appointment-Form.pdf"; // The name of the downloaded file
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up memory
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed:", error);
            alert("Failed to download the file.");
        }
    };




    const handleConfirmAcceptance = async () => {
        // Example: send API request or use handleAction
        try {
            setShowModal(false);

            const response = await updateAppoinmentStatus(selectedUser.id, modalType)
            if (response.data.status === 200) {

                alert("Appointment accepted successfully.");
            }
            getUser()

        } catch (err) {
            console.error("Failed to confirm:", err);
            alert("Failed to confirm appointment.");
        }
    };

    const handleReject = async () => {
        try {
            console.log("selectedUser, modalType", selectedUser, modalType);
            const response = await updateAppoinmentStatus(selectedUser.id, modalType)
            if (response.data.status === 200) {

                alert("Appointment rejected successfully.");
            }
            getUser()

            // await handleAction("reject");
        } catch (err) {
            console.error("Rejection failed", err);
        }
    };
    const filteredUsers = users.filter((user) => {
        const matchesEmail = user.email
            .toLowerCase()
            .includes(searchEmail.toLowerCase());

        const matchesStatus =
            statusFilter === "all" ||
            (statusFilter === "pending" && user.appoinmentstatus === null) ||
            (statusFilter === "accept" && user.appoinmentstatus === "accept") ||
            (statusFilter === "reject" && user.appoinmentstatus === "reject");

        return matchesEmail && matchesStatus;
    });

    const handleSendEmail = async (user: any) => {
        try {

            const response = await sendemailAndWhatsapp(user)
            console.log("response", response);

            // if (!response.ok) {
            //     throw new Error("Failed to send email");
            // }

            alert(`Email sent to ${user.email}`);
            getUser()
        } catch (error) {
            console.error("Error sending email:", error);
            alert("Something went wrong while sending email.");
        }
    };


    return (
        <Page>
            <Fullpage close={sidebar}>

                <div className="w-full min-h-screen p-6 bg-gray-50">
                    <div className="max-w-7xl mx-auto">
                        <div className="mb-6 flex justify-between items-center">
                            <h1 className="text-2xl font-bold">Guest User Panel</h1>
                            {user === "SuperAdmin" && (
                                <div className="flex gap-4">
                                    <label htmlFor="file" className="block px-4 py-2 rounded-lg bg-green-700  hover:bg-green-800 border-green-700 text-white">
                                        Upload Guest User
                                        <input type="file" id="file" name="file" accept=".xlsx" className="hidden" onChange={uploadDeptExcel} />
                                    </label>
                                    {/* <button className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
                                        Download Excel
                                    </button> */}
                                </div>
                            )}
                        </div>

                        {user === "SuperAdmin" ? (
                            <div className="overflow-x-auto bg-white rounded-xl shadow p-4">
                                <h2 className="text-lg font-semibold mb-4">Admin - User Management</h2>
                                <div className="flex items-center gap-4 mb-4">
                                    {/* Search by email */}
                                    <input
                                        type="text"
                                        placeholder="Search by email..."
                                        value={searchEmail}
                                        onChange={(e) => setSearchEmail(e.target.value)}
                                        className="px-3 py-2 border rounded-lg text-sm w-64"
                                    />

                                    {/* Select filter */}
                                    <select
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                        className="px-3 py-2 border rounded-lg text-sm"
                                    >
                                        <option value="all">All</option>
                                        <option value="pending">Pending</option>
                                        <option value="accept">Accepted</option>
                                        <option value="reject">Rejected</option>
                                    </select>
                                </div>
                                <table className="min-w-full text-sm text-left">
                                    <thead className="bg-gray-100 text-gray-600 uppercase">
                                        <tr>
                                            <th className="px-4 py-2">Name</th>
                                            <th className="px-4 py-2">Email</th>
                                            <th className="px-4 py-2">Phone</th>
                                            <th className="px-4 py-2">Document</th>
                                            <th className="px-4 py-2">Appointment Acceptance</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y">
                                        {filteredUsers.map(user => (
                                            <tr key={user.id} className="bg-white hover:bg-gray-50">
                                                <td className="px-4 py-2">{user.name}</td>
                                                <td className="px-4 py-2">{user.email}</td>
                                                <td className="px-4 py-2">{user.phone}</td>

                                                <td className="px-4 py-2">
                                                    {!user?.url ? (
                                                        // If no document, show upload input
                                                        <input
                                                            type="file"
                                                            accept="application/pdf"
                                                            onChange={(e) => {
                                                                const file = e.target.files?.[0];
                                                                if (file) handleUpload(user.id, "Appointment Letter", file);
                                                            }}
                                                            className="text-xs"
                                                        />
                                                    ) : (
                                                        // If document exists, show view & delete buttons
                                                        <div className="flex items-center gap-2">
                                                            <button
                                                                onClick={() => handleView(user.url)}
                                                                className="text-blue-600 hover:underline text-sm"
                                                            >
                                                                View
                                                            </button>
                                                            {/* <button
                                                                onClick={() => handleDeleteDocument(user.id, user.documentId)}
                                                                className="text-red-600 hover:underline text-sm"
                                                            >
                                                                Delete
                                                            </button> */}
                                                        </div>

                                                    )}
                                                </td>


                                                <td className="px-4 py-2 space-x-2">
                                                    {user.appoinmentstatus === "accept" && (
                                                        <span className="inline-block px-3 py-1 text-sm font-medium text-white bg-green-600 rounded">
                                                            Accepted
                                                        </span>
                                                    )}

                                                    {user.appoinmentstatus === "reject" && (
                                                        <span className="inline-block px-3 py-1 text-sm font-medium text-white bg-red-600 rounded">
                                                            Rejected
                                                        </span>
                                                    )}

                                                    {user.appoinmentstatus === null && (
                                                        <div className="flex items-center gap-2">
                                                            {/* Pending badge */}
                                                            <span className="inline-block px-3 py-1 text-sm font-medium text-white bg-yellow-500 rounded">
                                                                Pending
                                                            </span>

                                                            {/* Show buttons only if document exists */}
                                                            {user?.url && (
                                                                <>
                                                                    {/* 📧 Send email via API */}
                                                                    <button
                                                                        onClick={() => handleSendEmail(user)}
                                                                        className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 text-sm"
                                                                    >
                                                                        Send Email
                                                                    </button>

                                                                    {/* 📱 WhatsApp */}
                                                                    {/* <button
                                                                        onClick={() => window.open(`https://wa.me/${user.phone}`, "_blank")}
                                                                        className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 text-sm"
                                                                    >
                                                                        WhatsApp
                                                                    </button> */}
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>


                            </div>

                        ) : (
                            <div className="space-y-6">
                                <h2 className="text-2xl font-semibold text-gray-800">User View</h2>

                                <div className="overflow-x-auto bg-white rounded-2xl shadow-sm border border-gray-200">
                                    <table className="min-w-full table-auto text-sm text-left">
                                        <thead className="bg-gray-100 text-gray-700">
                                            <tr>
                                                <th className="px-6 py-3 font-semibold">Name</th>
                                                <th className="px-6 py-3 font-semibold">Email</th>
                                                <th className="px-6 py-3 font-semibold">Phone</th>
                                                <th className="px-6 py-3 font-semibold">Appoinment Letter</th>
                                                <th className="px-6 py-3 font-semibold">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users.map((user) => (
                                                <tr key={user.id} className="border-t hover:bg-gray-50">
                                                    <td className="px-6 py-4">{user.name}</td>
                                                    <td className="px-6 py-4">{user.email}</td>
                                                    <td className="px-6 py-4">{user.phone || "N/A"}</td>
                                                    <td className="px-6 py-4 space-x-2 whitespace-nowrap">
                                                        {user.url ? (
                                                            <>
                                                                <button
                                                                    onClick={() => handleView(user.url)}
                                                                    className="bg-green-700 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                                                                >
                                                                    view Appointment
                                                                    {/* <Eye className="w-4 h-4 mr-1" /> */}
                                                                </button>
                                                                {/* <a
                                                                    href={user.url}
                                                                    download={`${ user.name }_document`}
                                                                    className="inline-flex items-center text-green-600 hover:underline"
                                                                >
                                                                    <Download className="w-4 h-4 mr-1" />
                                                                    Download
                                                                </a> */}
                                                            </>
                                                        ) : (
                                                            <span className="text-gray-400">No Document</span>
                                                        )}
                                                    </td>

                                                    <td className="px-6 py-4 space-x-2 whitespace-nowrap">
                                                        {user.appoinmentstatus === null ? (
                                                            <>
                                                                <button
                                                                    onClick={() => {
                                                                        setSelectedUser(user);
                                                                        setModalType("accept");
                                                                        setShowModal(true);
                                                                    }}
                                                                    className="text-green-600 border border-green-600 px-3 py-1 rounded hover:bg-green-50"
                                                                >
                                                                    Appointment Acceptance
                                                                </button>

                                                                <button
                                                                    onClick={() => {
                                                                        setSelectedUser(user);
                                                                        setModalType("reject");
                                                                        setShowModal(true);
                                                                    }}
                                                                    className="text-red-600 border border-red-600 px-3 py-1 rounded hover:bg-red-50"
                                                                >
                                                                    Reject
                                                                </button>
                                                            </>
                                                        ) : user.appoinmentstatus === "accept" ? (
                                                            <span className="inline-block px-3 py-1 text-sm font-medium text-white bg-green-600 rounded">
                                                                Accepted
                                                            </span>
                                                        ) : (
                                                            <span className="inline-block px-3 py-1 text-sm font-medium text-white bg-red-600 rounded">
                                                                Rejected
                                                            </span>
                                                        )}

                                                        {showModal && selectedUser?.id === user.id && (
                                                            <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
                                                                <div className="bg-white rounded-lg p-6 w-full max-w-md space-y-4 shadow-xl overflow-y-auto max-h-[90vh]">
                                                                    <h2 className="text-lg font-semibold text-gray-800">
                                                                        {modalType === "accept" ? "Appointment Form Submission" : "Confirm Rejection"}
                                                                    </h2>

                                                                    <p className="text-sm text-gray-700 whitespace-normal break-words">
                                                                        {modalType === "accept"
                                                                            ? "Please download the appointment acceptance form, take a printout, fill it manually, and submit the signed hard copy to the university office."
                                                                            : "Are you sure you want to reject this appointment?"}
                                                                    </p>

                                                                    <div className="flex space-x-4 justify-end mt-4">
                                                                        {modalType === "accept" && (
                                                                            <button
                                                                                onClick={handleDownloadPDF}
                                                                                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                                                                            >
                                                                                Download PDF
                                                                            </button>
                                                                        )}

                                                                        <button
                                                                            onClick={() => {
                                                                                if (modalType === "accept") {
                                                                                    handleConfirmAcceptance();
                                                                                } else {
                                                                                    handleReject();
                                                                                }
                                                                                setShowModal(false);
                                                                            }}
                                                                            className={`${modalType === "accept" ? "bg-green-600" : "bg-red-600"
                                                                                } text-white px-4 py-2 rounded hover:opacity-90`}
                                                                        >
                                                                            {modalType === "accept" ? "Confirm" : "Confirm Reject"}
                                                                        </button>

                                                                        <button
                                                                            onClick={() => setShowModal(false)}
                                                                            className="text-gray-600 border px-4 py-2 rounded hover:bg-gray-100"
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </td>




                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>


                                </div>
                            </div>
                        )}
                    </div>

                    <DocumentPreview
                        isOpen={isPreviewOpen}
                        onClose={() => setIsPreviewOpen(false)}
                        fileUrl={previewFileUrl}
                        fileType={previewFileType}
                    />
                </div>
            </Fullpage>
        </Page>
    );
}
